import React from "react";

function FormTags({ tag, onChange, checked }) {
  var correctTags = tag?.toLowerCase();
  var correctCheckedUntrimmed = checked?.toString().toLowerCase().split(",");
  const correctChecked = correctCheckedUntrimmed?.map((element) => {
    return element.trim();
  });

  return (
    <div>
      <label>
        <input
          style={{ display: "none" }}
          type="checkbox"
          onChange={onChange}
          name={tag}
          value={tag}
          checked={correctChecked.includes(correctTags)}
          disabled={
            !correctChecked.includes(correctTags) && correctChecked.length === 3
          }
        />
        <div className="w-full sm:w-fit group h-[52px] z-50">
          <div
            className={
              correctChecked.includes(correctTags)
                ? "h-full bg-primary duration-500 ease-in-out z-50 border-[1px] border-primary relative cursor-pointer"
                : "h-full bg-primary/0 group-hover:bg-primary duration-500 ease-in-out z-50 border-[1px] border-primary relative cursor-pointer"
            }
          >
            <span
              className={
                correctChecked.includes(correctTags)
                  ? "px-[20px] gap-x-4 h-full flex justify-center items-center text-tertiary duration-500 ease-in-out capitalize text-[14px] md:text-[15px] font-SoraR"
                  : "px-[20px] gap-x-4 h-full flex justify-center items-center text-primary  group-hover:text-tertiary duration-500 ease-in-out capitalize text-[14px] md:text-[15px] font-SoraR"
              }
            >
              <h3>{tag}</h3>
              <span
                className={
                  correctChecked.includes(correctTags)
                    ? "scale-150 rotate-45 duration-500 ease-out"
                    : "scale-150 rotate-0 duration-500 ease-out"
                }
              >
                +
              </span>
            </span>
          </div>
        </div>
      </label>
    </div>
  );
}

export default FormTags;
